// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"notesTabContent_mulitpleDropdown__2FQr_"};